import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center">
      <div className="font-mono text-[10.5px] tracking-[0.22em] uppercase text-[var(--ink-muted)]">Error · 404</div>
      <h1 className="h-display text-6xl font-semibold mt-3">Not found.</h1>
      <p className="text-[var(--ink-soft)] mt-3">The resource you requested is not available.</p>
      <Link to="/" className="btn-primary inline-flex mt-6">Back to home</Link>
    </div>
  );
}
